<template lang="pug">
shListData(title="Ubicaciones" resolver="locations" keyData="_id" keyData1="department" component="shLocation")
</template>

<script>
import shListData from '@/components/global/ListData'

export default {
  name: 'Locations',

  components: { shListData }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/location/Locations.vue